import { render, staticRenderFns } from "./FormCol.vue?vue&type=template&id=5c0f03b0&"
import script from "./FormCol.vue?vue&type=script&lang=ts&"
export * from "./FormCol.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports